/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'n_arrow-right': {
    width: 13,
    height: 12,
    viewBox: '0 0 13 12',
    data: '<path d="M9.5535 5.83399L10.822 5.83398L9.89466 4.96846L6.28978 1.6039L6.56836 1.34846L11.5528 6.00065L6.56836 10.6528L6.28978 10.3974L9.89466 7.03285L10.822 6.16732L9.5535 6.16732L1.35708 6.16732L1.35708 5.83399L9.5535 5.83399Z" fill="currentColor" stroke="currentColor"/>'
  }
})